export enum StatusEnum{
  DRAFT = "DRAFT",
  PENDING= 'PENDING',
  CONFIRMED = 'CONFIRMED',
  REJECTED = 'REJECTED',
  CANCELED = 'CANCELED',
  SUCCEED = 'SUCCEED',
  FAILED = 'FAILED',
  WAITING = 'WAITING',
  IN_PROGRESS= 'IN_PROGRESS',
  TRANSFERRED= 'TRANSFERRED'
}
